import LoadingView from './src/LoadingView';
import Loading from './src/Loading';

export { Loading };
export default LoadingView;
